import React from "react";

export const Footer = () => (
  <footer className="footer ">
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 h-100 text-center text-lg-left my-auto">
          <ul className="list-inline mb-2">
            <li className="list-inline-item">
              <a href="/">Home</a>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a href="/tos">Terms of Service</a>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a href="/privacy">Privacy Policy</a>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a href="mailto:info@glowplug.app">Contact</a>
            </li>
          </ul>
          <p className="text-muted small mb-4 mb-lg-0">
            &copy; Good Car Ideas {new Date().getFullYear()}. All rights
            reserved.
          </p>
        </div>
        {/* <div className="col-lg-6 h-100 text-center text-lg-right my-auto">
          <ul className="list-inline mb-0">
            <li className="list-inline-item mr-3">
              <a href="#">
                <i className="fab fa-facebook fa-2x fa-fw"></i>
              </a>
            </li>
            <li className="list-inline-item mr-3">
              <a href="#">
                <i className="fab fa-twitter-square fa-2x fa-fw"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="#">
                <i className="fab fa-instagram fa-2x fa-fw"></i>
              </a>
            </li>
          </ul>
        </div> */}
      </div>
    </div>
  </footer>
);
